import React, { useEffect, useState } from "react";

import { delay } from "../../../utils";
import { daysOfWeek } from "../../../constants";

import { updateOrderRule } from "../../../service/api/OrderRule/apiOrderRule";

const SetOrderRule = ({ data }) => {
  useEffect(() => {
    if (Object.entries(data).length > 0) {
      console.log(data)
      setRules({
        canUseDays: data.canUseDays.map(String), // 轉成字串
        maxOrderAmount: data.maxOrderAmount,
        deliveryFee: data.deliveryFee
      });
    }
  }, [data]);
  const [rules, setRules] = useState({
    canUseDays: [],
    maxOrderAmount: "",
    deliveryFee: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false); // 新增成功狀態
  const handleDayToggle = (day) => {
    setRules((prev) => {
      if (prev.canUseDays.includes(day)) {
        return { ...prev, canUseDays: prev.canUseDays.filter((d) => d !== day) };
      } else {
        return { ...prev, canUseDays: [...prev.canUseDays, day] };
      }
    });
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setRules(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const response = await updateOrderRule(rules);
    console.log(response);
    await delay(1); // 等待 1 秒
    if (response.data.status === 1 && response.status === 200) {

      console.log("設定好的規則：", rules);

      setLoading(false);
      setSuccess(true); // 顯示打勾
      setTimeout(() => setSuccess(false), 1000); // 1 秒後回到原本文字
    } else {
      alert("規則更新失敗");
      setLoading(false);
      setSuccess(true); // 顯示打勾
      setSuccess(false)
      return
    }
  };

  return (
    <div className="container mt-4">
      <div className="card shadow p-4 border-0">
        <h4 className="mb-3 text-primary">規則設定</h4>
        <form onSubmit={handleSubmit}>
          {/* 可使用天數 */}
          <div className="mb-3">
            <label className="form-label fw-bold">可使用天數</label>
            <div className="d-flex flex-wrap gap-2">
              {daysOfWeek.map((day) => (
                <button
                  type="button"
                  key={day.value}
                  className={`btn ${rules.canUseDays.includes(day.value) ? "btn-success" : "btn-outline-secondary"}`}
                  onClick={() => handleDayToggle(day.value)}
                >
                  {day.label}
                </button>
              ))}
            </div>
          </div>

          {/* 最大訂單數量 */}
          <div className="mb-3">
            <label className="form-label fw-bold">最大訂單數量</label>
            <input
              type="number"
              className="form-control"
              name="maxOrderAmount"
              value={rules.maxOrderAmount}
              onChange={handleChange}
              placeholder="請輸入數量"
              required
            />
          </div>

          {/* 最大訂單數量 */}
          <div className="mb-3">
            <label className="form-label fw-bold">運費</label>
            <input
              type="number"
              className="form-control"
              name="deliveryFee"
              value={rules.deliveryFee}
              onChange={handleChange}
              placeholder="請輸入金額"
              required
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary w-100 rounded-pill"
            disabled={loading}
          >
            {loading ? (
              <span className="spinner-border spinner-border-sm"></span>
            ) : success ? (
              <span>&#10003; 已儲存</span> // 打勾顯示
            ) : (
              "儲存設定"
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export { SetOrderRule };
